export default {
  header: 'Select a template step',
  submit: 'Insert {templateStep}',
};
